import React, { useContext, useEffect, useState } from "react";
import "../../css_files/Enquiry/Enquiry.css";
import EnquiryCard from "./EnquiryCard";
import EnquiryType from "./EnquiryType";
import ServiceEnquiry from "./ServiceEnquiry";
import { triggerscroll } from "../Homepage/Homepage";
import EnquiryTable from "./EnquiryTable";
import { toast, ToastContainer } from "react-toastify";
import axiosInstance from "../../api";
import EnquiryInfo from "./EnquiryInfo";
import Pagination from "../Homepage/Pagination";

function Enquiries({ setEnquiryId }) {
  const [showEnquiryType, setShowEnquiryType] = useState(false);
  const [enquiryType, setEnquiryType] = useState("Service");
  const [showServiceEnquiry, setShowServiceEnquiry] = useState(false);
  const [triggerEnquiry, setTriggerEnquiry] = useState({
    update: false,
    seriesId: "",
  });

  const [serviceEnquiries, setServiceEnquiries] = useState([]);
  const [refresh, setrefresh] = useState(false);
  const { setExpiredSession, userData, permissionsdata } =
    useContext(triggerscroll);
  const [showenquiryInfo, setshowenquiryInfo] = useState(false);
  const [companyData, setCompanyData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [addressData, setAddressData] = useState([]);
  const [customerBoilerData, setCustomerBoilerData] = useState([]);
  const [enquiryinfodata, setenquiryinfodata] = useState(null);
  const [viewType, setViewType] = useState("GridView");
  const [loading, setloading] = useState(false);
  const [rotateReload, setRotateReload] = useState({
    reloadCompanyName: false,
    rotateCompanyName: false,
    rotateCustomerName: false,
    rotateCustomerAddress: false,
    rotateCustomerBoilerName: false,
  });
  const [page, setpage] = useState(1);
  const [pages, setpages] = useState(0);
  const [counts, setcounts] = useState(0);
  const [excelLoading, setExcelLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchServiceEnquiries = async () => {
      setServiceEnquiries([]);
      setloading(true);
      try {
        const res = await axiosInstance.get(
          `${process.env.REACT_APP_API_URL}/api/v1/NewEnquiry?page=${page}&type=${enquiryType}&search=${searchTerm}`
        );

        setpages(res.data.pages);
        setcounts(res.data.count);
        setServiceEnquiries(res.data.data);
      } catch (err) {
        console.log(err);
      } finally {
        setloading(false);
      }
    };

    fetchServiceEnquiries();
  }, [refresh, page, enquiryType, searchTerm]);

  useEffect(() => {
    setRotateReload({ ...rotateReload, rotateCompanyName: true });
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Customer/GetCustomerDropdown`
      )
      .then((res) => {
        setCompanyData(res.data);
      })
      .catch(console.log)
      .finally(() => {
        setRotateReload({ ...rotateReload, rotateCompanyName: false });
      });
  }, [rotateReload.reloadCompanyName]);

  function getCustomerDetailsByCompanyId(id) {
    setRotateReload({ ...rotateReload, rotateCustomerName: true });
    setCustomerData([]);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/ContactCentres/GetContactCenterByCustomerId?CustomerId=${id}`
      )
      .then((res) => {
        setCustomerData(res.data);
        setRotateReload({ ...rotateReload, rotateCustomerName: false });
      })
      .catch((err) => {
        console.log(err);
        setRotateReload({ ...rotateReload, rotateCustomerName: false });
      });
  }

  function getCustomerAddressByCompanyId(id) {
    setRotateReload({ ...rotateReload, rotateCustomerAddress: true });
    setAddressData([]);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/Addresses/GetAdressByCustomerId?CustomerId=${id}`
      )
      .then((res) => {
        setAddressData(res.data);
        setRotateReload({ ...rotateReload, rotateCustomerAddress: false });
      })
      .catch((err) => {
        console.log(err);
        setRotateReload({ ...rotateReload, rotateCustomerAddress: false });
      });
  }

  function getCustomerBoilerByCompanyId(id) {
    setRotateReload({ ...rotateReload, rotateCustomerBoilerName: true });
    setCustomerData([]);
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/CustomerBoilers/GetCustomerBoilerByCustomerId?CustomerId=${id}`
      )
      .then((res) => {
        setCustomerBoilerData(res.data);
        setRotateReload({ ...rotateReload, rotateCustomerBoilerName: false });
      })
      .catch((err) => {
        console.log(err);
        setRotateReload({ ...rotateReload, rotateCustomerBoilerName: false });
      });
  }

  function readPermission() {
    if (userData.role === "Administrator") return true;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" && x.subHead === "Enquiry" && x.isRead === true
    );
    return issatisfied;
  }

  function writePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" && x.subHead === "Enquiry" && x.isWrite === true
    );
    return !issatisfied;
  }

  function updatePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" &&
        x.subHead === "Enquiry" &&
        x.isUpdate === true
    );
    return !issatisfied;
  }

  function deletePermission() {
    if (userData.role === "Administrator") return false;

    const issatisfied = permissionsdata.some(
      (x) =>
        x.head === "Operations" &&
        x.subHead === "Enquiry" &&
        x.isDelete === true
    );
    return !issatisfied;
  }

  return (
    <>
      <section className="enquiries">
        <div className="enquiries-div">
          <aside>
            <blockquote>
              <h1>Enquiries</h1>
              <p>Track all service and parts requests</p>
            </blockquote>
            <blockquote>
              <input
                type="search"
                placeholder="Enter Search Term (Press Enter Key)"
                onInput={(e) => {
                  if (e.target.value === "") {
                    setSearchTerm("");
                    setrefresh(!refresh);
                    setpage(1);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    setSearchTerm(e.target.value?.trim());
                    setpage(1);
                  }
                }}
              />

              <button
                onClick={() => setShowEnquiryType(true)}
                style={{
                  pointerEvents: writePermission() && "none",
                  opacity: writePermission() && 0.5,
                }}
              >
                <i className="fa-solid fa-plus"></i>
                <p>New Enquiry</p>
              </button>
              <button
                onClick={() => setViewType("GridView")}
                style={{
                  backgroundColor: viewType === "GridView" && "blue",
                  color: viewType === "GridView" && "white",
                  padding: "0.5rem 1rem",
                }}
              >
                <i
                  class="fa-solid fa-table-cells-large"
                  style={{ fontSize: "2rem" }}
                ></i>
              </button>
              <button
                onClick={() => setViewType("ListView")}
                style={{
                  backgroundColor: viewType === "ListView" && "blue",
                  color: viewType === "ListView" && "white",
                  padding: "0.5rem 1rem",
                }}
              >
                <i class="fa-solid fa-bars" style={{ fontSize: "2rem" }}></i>
              </button>
              {/*excelLoading ? (
                <button>
                  <i className="fa-solid fa-rotate-right fa-spin"></i>
                </button>
              ) : (
                <button
                  onClick={() => {
                    setExcelLoading(true);
                    axiosInstance
                      .get(
                        `${process.env.REACT_APP_API_URL}/api/Excel/DataBackup?name=Enquiry`,
                        { responseType: "blob" }
                      )
                      .then((res) => {
                        const blob = new Blob([res.data]);
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement("a");
                        a.download = `Enquiry_${new Date().getMilliseconds()}.xlsx`;
                        a.href = url;
                        a.click();
                        window.URL.revokeObjectURL(url);
                        toast.success("Data Exported to Excel Successfully", {
                          position: "bottom-center",
                          theme: "dark",
                        });
                        setExcelLoading(false);
                      })
                      .catch((err) => {
                        console.log(err);
                        setExcelLoading(false);
                      });
                  }}
                >
                  <i class="fa-solid fa-file-export"></i>
                </button>
              )*/}
            </blockquote>
          </aside>
        </div>

        <section className="enquiries-section">
          <aside id="enquirysectionaside">
            <blockquote>
              <button>
                <i
                  className={`fa-solid ${
                    enquiryType === "Service" ? "fa-wrench" : "fa-box"
                  } `}
                ></i>
              </button>
              <h2>{enquiryType} Requests</h2>
              <button
                style={{ cursor: "pointer" }}
                onClick={() => {
                  enquiryType === "Service"
                    ? setEnquiryType("Parts")
                    : setEnquiryType("Service");
                  setpage(1);
                }}
              >
                <i class="fa-solid fa-repeat"></i>
              </button>
            </blockquote>
            <button>{counts} active</button>
          </aside>

          {viewType === "ListView" &&
            (loading ? (
              <div>
                <center>
                  <i className="fa-solid fa-snowflake fa-3x fa-spin"></i>
                </center>
              </div>
            ) : readPermission() ? (
              <div className="enquiry-cards">
                {serviceEnquiries.length > 0 ? (
                  serviceEnquiries.map((serviceEnquiry, index) => (
                    <EnquiryCard
                      key={index}
                      name={serviceEnquiry.customerName}
                      email={serviceEnquiry.customerEmail}
                      phone={serviceEnquiry.customerPhoneNumber}
                      date={serviceEnquiry.dateOfEnquiry}
                      id={serviceEnquiry.seriesID}
                      priority={serviceEnquiry.priority}
                      location={serviceEnquiry.address}
                      setEnquiryId={setEnquiryId}
                      isTicketCreated={serviceEnquiry.isTicketCreated}
                      setenquiryinfodata={setenquiryinfodata}
                      setshowenquiryInfo={setshowenquiryInfo}
                      infodata={serviceEnquiry}
                    />
                  ))
                ) : (
                  <center>
                    <p>No Records Found</p>
                  </center>
                )}
              </div>
            ) : (
              <div>
                <center>
                  <p>You Do Not Have Permission To Read Data</p>
                </center>
              </div>
            ))}
        </section>
        {viewType === "GridView" && (
          <EnquiryTable
            serviceEnquiries={serviceEnquiries}
            setShowServiceEnquiry={setShowServiceEnquiry}
            setTriggerEnquiry={setTriggerEnquiry}
            setrefresh={setrefresh}
            refresh={refresh}
            setEnquiryId={setEnquiryId}
            setenquiryinfodata={setenquiryinfodata}
            setshowenquiryInfo={setshowenquiryInfo}
            loading={loading}
            readPermission={readPermission}
            writePermission={writePermission}
            updatePermission={updatePermission}
            deletePermission={deletePermission}
          />
        )}
        <br />
        <Pagination count={pages} pagenumber={page} setpagenumber={setpage} />
      </section>
      {showEnquiryType && (
        <EnquiryType
          setShowEnquiryType={setShowEnquiryType}
          setShowServiceEnquiry={setShowServiceEnquiry}
          setTriggerEnquiry={setTriggerEnquiry}
          triggerEnquiry={triggerEnquiry}
          setEnquiryType={setEnquiryType}
        />
      )}
      {showServiceEnquiry && (
        <ServiceEnquiry
          setShowServiceEnquiry={setShowServiceEnquiry}
          refresh={refresh}
          showServiceEnquiry={showServiceEnquiry}
          setrefresh={setrefresh}
          companyData={companyData}
          customerData={customerData}
          addressData={addressData}
          customerBoilerData={customerBoilerData}
          getcustomer={getCustomerDetailsByCompanyId}
          getaddress={getCustomerAddressByCompanyId}
          getboiler={getCustomerBoilerByCompanyId}
          triggerEnquiry={triggerEnquiry}
          rotateReload={rotateReload}
          setRotateReload={setRotateReload}
          enquiryType={enquiryType}
        />
      )}
      {showenquiryInfo && (
        <EnquiryInfo
          setshowenquiryInfo={setshowenquiryInfo}
          enquiryinfodata={enquiryinfodata}
        />
      )}
    </>
  );
}

export default Enquiries;
